<ngx-axs-hero
  axsDefaultType="background"
  axsMobileType="background"
  axsPictureImgSrc="./assets/images/yellow-hero-background.svg"
  axsTheme="grey"
  axsMinHeight="short"
  axsSafetyPadding="md"
  axsEyebrowText="{{heroContent.subHeader}}"
>
  <ng-container axsHeroContent>
    <div class="axs-hero-container v4-hero">
      <div class="axs-theme-color pad-bottom-6">

        <h1 class="pad-bottom-4">{{heroContent.header}}</h1>
        <p class="pad-bottom-2">{{heroContent.description}}</p>
      </div>
    </div>
  </ng-container>
</ngx-axs-hero>
